import { Box, Typography, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';

import {
  AllocationSummaryTable,
  DatasetSummary,
  ProjectBasics,
  ReviewConceptAndAttributes,
  type AllocationSummary,
  type Concept,
} from '@verantos-dev/feature-annotation-project-admin';
import { PeopleSection } from '@verantos-dev/ui-annotation-tool';

import { useSupervisorProjectOverview } from './useSupervisorProjectOverview';

export const SupervisorProjectOverview = () => {
  const theme = useTheme();
  const { formatMessage } = useIntl();
  const {
    projectName,
    conditionAreaName,
    healthSystemName,
    annotatorNames,
    supervisorNames,
    addedConcepts,
    validationEncounterCount,
    testEncounterCount,
    trainingEncounterCount,
    allocationSummary,
    isDataLoading,
  } = useSupervisorProjectOverview();

  return (
    <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: theme.spacing(4) }}>
      <Box>
        <Typography variant="h5">
          {formatMessage({ id: 'adminProjects.projectOverview.title' })}
        </Typography>
      </Box>
      <Box>
        <ProjectBasics
          projectName={projectName}
          conditionAreaName={conditionAreaName}
          healthSystemName={healthSystemName}
        />
      </Box>
      <Box>
        <PeopleSection
          annotatorNames={annotatorNames}
          supervisorNames={supervisorNames}
          isLoading={isDataLoading}
        />
      </Box>
      <Box sx={{ display: 'flex', gap: theme.spacing(2) }}>
        <Box sx={{ flexGrow: 1 }}>
          <ReviewConceptAndAttributes
            addedConcepts={addedConcepts as Concept[]}
            isLoading={isDataLoading}
          />
        </Box>
        <Box
          id="review-sidebar"
          sx={{
            width: '450px',
            p: theme.spacing(4),
            display: 'flex',
            flexDirection: 'column',
            gap: theme.spacing(4),
          }}
        >
          <DatasetSummary
            validationEncounterCount={validationEncounterCount}
            testEncounterCount={testEncounterCount}
            trainingEncounterCount={trainingEncounterCount}
            isLoading={isDataLoading}
          />
          <AllocationSummaryTable
            allocationSummary={allocationSummary as AllocationSummary[]}
            isLoading={isDataLoading}
          />
        </Box>
      </Box>
    </Box>
  );
};
